import { alpha, CircularProgress, styled } from '@mui/material'

export function LoadingStories({ isLoading }: { isLoading: boolean }) {
  return (
    <>
      {isLoading && (
        <Root>
          <CircularProgress size={48} sx={{ color: 'neutral000' }} />
        </Root>
      )}
    </>
  )
}

const Root = styled('div')`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${({ theme }) => alpha(theme.palette.neutral1000, 0.3)};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 50px;
`
